module.exports = __webpack_public_path__ + "static/media/BannerMockup.870f45d2.jpg";